import React from 'react';
import { Link } from 'react-router-dom';
import { Sun, ArrowRight } from 'lucide-react';

const LunchResetStrip = () => (
  <section className="bg-amber-50 border-b border-amber-200" data-testid="lunch-reset-strip">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex flex-col sm:flex-row sm:items-center justify-between gap-3">
      <p className="flex items-center gap-3 text-sm md:text-base text-gray-800">
        <Sun className="w-5 h-5 text-amber-500 shrink-0" />
        <span>
          <strong className="font-semibold">Midtown Lunch Reset</strong> — 30 minutes, $55 · Tue–Sat, 11 AM – 2 PM
        </span>
      </p>
      <Link
        to="/massage-midtown-sacramento#lunch-reset"
        className="group inline-flex items-center gap-1 text-sm font-medium text-gray-900 hover:text-amber-700 transition-colors duration-300 whitespace-nowrap"
        data-testid="lunch-reset-strip-link"
      >
        See the lunch reset
        <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" />
      </Link>
    </div>
  </section>
);

export default LunchResetStrip;
